export default __webpack_public_path__ + "static/media/chiliz.30e20cac.png";